import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";

/**
 * The MSAL instance used for authentication.
 * It takes the configuration object defined in `authConfig` as a parameter.
 */
export const msalInstance = new PublicClientApplication(msalConfig);
msalInstance.enableAccountStorageEvents();
